import { createApp } from 'vue'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import App from './App.vue'
import router from './router'
import store from './store'
import "./assets/style/common.css"
import "./assets/style/element.css"
import locale from "element-plus/dist/locale/zh-cn.mjs"
import VueCookies from 'vue3-cookies'
import VueClipboard from 'vue-clipboard2'

const app = createApp(App)
app.config.globalProperties.$imgBaseUrl = "https://files.quandashi.com/"

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

app.use(store).use(router).use(ElementPlus, {locale}).use(VueCookies).use(VueClipboard).mount('#app')
